import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import Meta from '../../components/layout/Meta';
import config from '../../config';

const CareersScreen = () => {
    const brandColor = '#b5430f';

    const jobs = [
        {
            id: 1,
            title: 'Desarrollador Frontend Senior',
            department: 'Tecnología',
            location: 'Remoto / Bogotá',
            type: 'Tiempo Completo',
            description: 'Buscamos un experto en React y Redux para liderar nuestro equipo de frontend.'
        },
        {
            id: 2,
            title: 'Especialista en Marketing Digital',
            department: 'Marketing',
            location: 'Bogotá',
            type: 'Tiempo Completo',
            description: 'Encargado de gestionar campañas en redes sociales y SEO para nuestra marca.'
        },
        {
            id: 3,
            title: 'Asesor de Ventas Corporativas',
            department: 'Ventas',
            location: 'Medellín',
            type: 'Híbrido',
            description: 'Responsable de expandir nuestra red de alianzas con empresas del sector hogar.'
        }
    ];

    return (
        <>
            <Meta title="Trabaja con Nosotros" />
            
            {/* Hero Section */}
            <div className="text-white py-5 text-center" style={{ backgroundColor: brandColor }}>
                <Container>
                    <h1 className="display-4 fw-bold">Únete a nuestro equipo</h1>
                    <p className="lead">Ayúdanos a transformar los hogares de miles de familias.</p>
                </Container>
            </div>

            <Container className="py-5">
                <Row className="justify-content-center mb-5">
                    <Col md={8} className="text-center">
                        <h2 className="mb-3" style={{ color: brandColor }}>¿Por qué trabajar en {config.company.name}?</h2>
                        <p className="text-muted">
                            En {config.company.name} valoramos la innovación, el trabajo en equipo y la pasión por el diseño.
                            Ofrecemos un ambiente dinámico, oportunidades de crecimiento y beneficios competitivos.
                        </p>
                    </Col>
                </Row>

                <h3 className="mb-4" style={{ color: brandColor }}>Vacantes Disponibles</h3>
                <Row>
                    {jobs.map(job => (
                        <Col md={6} lg={4} key={job.id} className="mb-4">
                            <Card className="h-100 shadow-sm border-0 hover-card">
                                <Card.Body className="d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <Badge bg="light" text="dark" className="border">{job.department}</Badge>
                                        <Badge bg="secondary">{job.type}</Badge>
                                    </div>
                                    <Card.Title className="fw-bold mb-3">{job.title}</Card.Title>
                                    <Card.Subtitle className="mb-3 text-muted small">
                                        <i className="fas fa-map-marker-alt me-1"></i> {job.location}
                                    </Card.Subtitle>
                                    <Card.Text className="text-muted flex-grow-1">
                                        {job.description}
                                    </Card.Text>
                                    <Button 
                                        variant="outline-dark" 
                                        className="mt-3 w-100"
                                        style={{ borderColor: brandColor, color: brandColor }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = brandColor;
                                            e.target.style.color = 'white';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = brandColor;
                                        }}
                                    >
                                        Aplicar Ahora
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <div className="text-center mt-5 p-5 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <h3 className="mb-3">¿No encuentras tu rol ideal?</h3>
                    <p className="text-muted mb-4">
                        Siempre estamos buscando talento. Envíanos tu hoja de vida y te tendremos en cuenta para futuras oportunidades.
                    </p>
                    <Button 
                        size="lg" 
                        className="border-0"
                        style={{ backgroundColor: brandColor }}
                    >
                        Enviar Hoja de Vida Espontánea
                    </Button>
                </div>
            </Container>
        </>
    );
};

export default CareersScreen;
